var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.5,
    height: 60.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconData_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 282",
    fill: "#a1a1a1",
    stroke: "#707070",
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconData_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 331",
    fill: "none",
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "IconData_svg__a",
    x: 0,
    y: 0,
    width: 60.5,
    height: 60.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#IconData_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "IconDataButton",
    fill: "#fff",
    stroke: "#707070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 7.5,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconData_svg__b)",
    "data-name": "IconData"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "IconData",
    clipPath: "url(#IconData_svg__c)",
    fill: "#040000"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 344",
    d: "M49 46.539h-2.461V21.765h-7.465v24.774h-2.461v-14.93H29.23v14.93h-2.46V26.687h-7.383v19.852h-2.461V34.073H9.461v12.466H7V49h42z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 345",
    d: "M49 16.844V7h-9.926v2.461h5.725l-11.877 11.8-9.844-9.848L7.361 27.048 9.1 28.789l13.978-13.9 9.844 9.844L46.539 11.2v5.642z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconData);
export default __webpack_public_path__ + "static/media/IconData.111307872c47d7ee.svg";
export { ForwardRef as ReactComponent };